import React, { useEffect, useState } from 'react';
import './Skills.css';
import { getSkills } from '../queries/getSkills';

import { FaReact, FaNodeJs, FaAws, FaDocker, FaJava, FaWindows, FaUser, FaApple, FaLinux, FaMicrosoft } from 'react-icons/fa';
import { VscAzure, VscTerminalPowershell } from "react-icons/vsc";
import { IoDocument } from "react-icons/io5";
import { DiMsqlServer, DiJavascript } from "react-icons/di";
import { SiRubyonrails, SiTypescript, SiPostgresql, SiCitrix, SiPrometheus, SiVmware, SiMysql, SiKubernetes, SiGooglecloud, SiSpringboot, SiPhp, SiNetlify, SiHeroku, SiRabbitmq, SiImessage } from 'react-icons/si';
import { Skill } from '../types';

const iconMap: { [key: string]: JSX.Element } = {
  SiRubyonrails: <SiRubyonrails />,
  FaNodeJs: <FaNodeJs />,
  SiSpringboot: <SiSpringboot />,
  FaJava: <FaJava />,
  SiPhp: <SiPhp />,
  FaReact: <FaReact />,
  SiTypescript: <SiTypescript />,
  DiJavascript: <DiJavascript />,
  FaAws: <FaAws />,
  FaDocker: <FaDocker />,
  SiPostgresql: <SiPostgresql />,
  SiMysql: <SiMysql />,
  SiKubernetes: <SiKubernetes />,
  SiGooglecloud: <SiGooglecloud />,
  SiHeroku: <SiHeroku />,
  SiNetlify: <SiNetlify />,
  SiRabbitmq: <SiRabbitmq />,
  SiImessage: <SiImessage />,
  VscAzure: <VscAzure />,
  VscTerminalPowershell: <VscTerminalPowershell />,
  DiMsqlServer: <DiMsqlServer />,
  FaWindows: <FaWindows />,
  FaApple: <FaApple />,
  FaLinux: <FaLinux />,
  FaMicrosoft: <FaMicrosoft />,
  SiVmware: <SiVmware />,
  IoDocument: <IoDocument />,
  FaUser: <FaUser />,
  SiCitrix: <SiCitrix />,
  SiPrometheus: <SiPrometheus />,

};



const Skills: React.FC = () => {

  const [skillsData, setSkillsData] = useState<Skill[]>([]);

  useEffect(() => {
    async function fetchSkills() {
      const data = await getSkills();
      setSkillsData(data);
    }

    fetchSkills()
  }, []);

  if (skillsData.length === 0) return <div>Loading...</div>;

  const skillsByCategory = skillsData.reduce((acc: any, skill: any) => {
    if (!acc[skill.category]) acc[skill.category] = [];
    acc[skill.category].push(skill);
    return acc;
  }, {});


  return (
    <div className="skills-container">
      {Object.keys(skillsByCategory).map((category, index) => (
        <div key={index} className="skill-category">
          <h3 className="category-title">{category}</h3>
          <div className="skills-grid">
            {skillsByCategory[category].map((skill: any, idx: number) => (
              <div key={idx} className="skill-card">
                <div className="icon">{iconMap[skill.icon] || <FaReact />}</div>
                <h3 className="skill-name">
                    {skill.name.split('').map((letter: string, i: number) => (
                    <span 
                        key={i} 
                        className="letter" 
                        style={{ animationDelay: `${i * 0.05}s`, display: letter === ' ' ? 'inline-block' : 'inline' }}
                        >
                        {letter === ' ' ? '\u00A0' : letter}
                    </span>
                    ))}
                </h3>

                <p className="skill-description">{skill.description}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Skills;
